const DB_NAME = 'payscription';
const CLIENTS_STORE_NAME = 'clients';
const PAGES_STORE_NAME = 'pages';

export default class ClientsDB {
    #db = null;

    open(onsuccess, onerror) {
        const openRequest = indexedDB.open(DB_NAME, 1);

        openRequest.onupgradeneeded = (event) => {
            this.#db = openRequest.result;
            switch (event.oldVersion) {
            case 0:
                this.initStore();
            }
        };

        openRequest.onsuccess = () => {
            this.#db = openRequest.result;
            // If we have a new tab with updated db version.
            this.#db.onversionchange = () => {
                this.#db?.close();
            };

            if (typeof onsuccess === 'function') {
                onsuccess();
            }
        };

        openRequest.onerror = () => {
            const errorName = openRequest.error.name;
            switch (errorName) {
            case 'VersionError':
                break;
            default:
                console.log('Unknown error');
            }
        };
    }

    /**
     * Add new clients or update existed.
     * @param {array} clients clients objects array
     */
    addClients(clients) {
        if (this.isOpened()) {
            const transaction = this.#db.transaction(CLIENTS_STORE_NAME, 'readwrite');
            const clientsStore = transaction.objectStore(CLIENTS_STORE_NAME);

            clients.forEach(client => {
                const request = clientsStore.put(client);

                request.onsuccess = function() {
                    console.log('Клиент добавлен в базу.', request.result);
                };

                request.onerror = function() {
                    console.log('Ошибка', request.error);
                };
            });
        }
    }

    /**
     * Load all clients from db.
     * @returns {Promise}
     */
    loadAllClients() {
        if (this.isOpened()) {
            const transaction = this.#db.transaction(CLIENTS_STORE_NAME, 'readonly');
            const clients = transaction.objectStore(CLIENTS_STORE_NAME);

            return new Promise((resolve, reject) => {
                const request = clients.getAll();
                request.onsuccess = () => resolve(request.result);
                request.onerror = () => reject(request.error);
            });
        }
    }

    addForms(forms) {
        if (this.isOpened()) {
            this.clearStore(PAGES_STORE_NAME, () => {
                forms.forEach(form => {
                    const transaction = this.#db.transaction(PAGES_STORE_NAME, 'readwrite');
                    const pagesStore = transaction.objectStore(PAGES_STORE_NAME);
                    const request = pagesStore.put(form);

                    request.onsuccess = function() {};

                    request.onerror = function() {
                        console.log('Ошибка', request.error);
                    };
                });
            });
        }
    }

    loadForms() {
        if (this.isOpened()) {
            const transaction = this.#db.transaction(PAGES_STORE_NAME, 'readonly');
            const forms = transaction.objectStore(PAGES_STORE_NAME);

            return new Promise((resolve, reject) => {
                const request = forms.getAll();
                request.onsuccess = () => resolve(request.result);
                request.onerror = () => reject(request.error);
            });
        }
    }

    deleteFormById(formId) {
        if (this.isOpened()) {
            const transaction = this.#db.transaction(PAGES_STORE_NAME, 'readwrite');
            const pagesStore = transaction.objectStore(PAGES_STORE_NAME);
            const request = pagesStore.delete(formId);

            request.onsuccess = function() {
                console.log('Страница оплаты удалена из базы');
            };

            request.onerror = function() {
                console.log('Не удалось удалить страницу из базы', request.error);
            };
        }
    }

    /**
     * Is database successfully opened.
     */
    isOpened() {
        if (!(this.#db instanceof IDBDatabase)) {
            console.error("Database '" + CLIENTS_STORE_NAME + "' is not opened now.");

            return false;
        }

        return true;
    }

    /**
     * Init clients store for v1.
     */
    initStore() {
        if (!this.#db.objectStoreNames.contains(CLIENTS_STORE_NAME)) {
            this.#db.createObjectStore(CLIENTS_STORE_NAME, { keyPath: 'id' });
        }

        if (!this.#db.objectStoreNames.contains(PAGES_STORE_NAME)) {
            this.#db.createObjectStore(PAGES_STORE_NAME, { keyPath: 'id' });
        }
    }

    /**
     * Delete clients object store.
     */
    clearStore(storeName, onSuccess, onError) {
        if (this.isOpened()) {
            const transaction = this.#db.transaction(storeName, 'readwrite');
            const store = transaction.objectStore(storeName);
            const request = store.clear();

            request.onsuccess = onSuccess;
            request.onerror = onError;
        }
    }

    /**
     * Delete clients database.
     */
    deleteDatabase() {
        const deleteRequest = indexedDB.deleteDatabase(DB_NAME);
        deleteRequest.onsuccess = function() {
            console.info('База данных клиентов удалена.');
        };
    }
};
